import { SupportAgent } from "@mui/icons-material";

const TypingIndicator = () => {
  return (
    <div style={{ display: 'flex', gap: '0.75rem', marginBottom: '1rem' }}>
      <div style={{ flexShrink: 0, width: '2rem', height: '2rem', borderRadius: '9999px', backgroundColor: '#f7f7f7', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <SupportAgent style={{ width: '1rem', height: '1rem', color: '#717171' }} />
      </div>

      <div style={{ backgroundColor: '#fff', border: '1px solid #e5e5e5', borderRadius: '1rem', borderBottomLeftRadius: '0.375rem', paddingLeft: '1rem', paddingRight: '1rem', paddingTop: '0.75rem', paddingBottom: '0.75rem', boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)' }}>
        <div style={{ display: 'flex', marginLeft: '-0.25rem', marginRight: '-0.25rem' }}>
          <div style={{ width: '0.5rem', height: '0.5rem', backgroundColor: '#a3a3a3', borderRadius: '9999px', animation: 'bounce 1s infinite' }}></div>
          <div
            style={{ animationDelay: "0.1s", width: '0.5rem', height: '0.5rem', backgroundColor: '#a3a3a3', borderRadius: '9999px', animation: 'bounce 1s infinite' }}
          ></div>
          <div
            style={{ animationDelay: "0.2s", width: '0.5rem', height: '0.5rem', backgroundColor: '#a3a3a3', borderRadius: '9999px', animation: 'bounce 1s infinite' }}
          ></div>
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;
